import { useRef, useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import { DELETE_SCHEDULE } from '../actions/types';
import { siteboardAction, setDeleteScheduleDialogueId } from '../actions/defaultActions';
import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

const DeleteScheduleDialogue = ({ _projects, _schedules, _deleteScheduleDialogueId, setDeleteScheduleDialogueId, siteboardAction }) => {
  const inputRef = useRef(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState('');

  const closeDialogue = useCallback(() => {
    setDeleteScheduleDialogueId(null);
  }, [setDeleteScheduleDialogueId]);

  // focus input when component is shown
  useEffect(() => {
    //try { inputRef.current.focus(); } catch(error) {}
  }, []);

  const selectedSchedule = _schedules[_deleteScheduleDialogueId];
  if(selectedSchedule === undefined) return (<></>);

  const selectedProject = _projects[selectedSchedule.projectId];
  if(selectedProject === undefined) return (<></>);

  return (
    <PopupWindow title='Delete 3-Week' closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-[400px] bg-[#333] text-white'>
        <div className=''>
          Delete this 3-week schedule for project <b>"{selectedProject.name}"</b> starting on <b>{selectedSchedule.beginDate}</b>? This action cannot be undone.
        </div>
        <div className='mt-5'>
          To avoid unintentional deletions, we ask you to provide additional confirmation.
        </div>
        <div className='font-bold mt-5'>
          To confirm this deletion, type "confirm".
        </div>
        <div className='mt-1'>
          <input 
            ref={inputRef}
            className='w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]' 
            type='text' 
            value={deleteConfirmation}
            onChange={(event) => { 
              setDeleteConfirmation(event.target.value); 
            }}
          />
        </div>
        <div className='flex mt-4'>
          <PushButton 
            textColor='white'
            bgColor='bg-red-800'
            hoverBgColor='bg-red-600'
            disabled={deleteConfirmation.toLowerCase() !== 'confirm'}
            onClick={() => {
              siteboardAction(DELETE_SCHEDULE, {
                scheduleId: selectedSchedule.id,
                projectId: selectedProject.id,
                subscriptionId : selectedProject.subscriptionId,
              }, (output) => { closeDialogue(); });
            }}
          >
            Delete 3-Week
          </PushButton>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _schedules: state.serverSynced.schedules,
  _deleteScheduleDialogueId: state.localEphemeral.deleteScheduleDialogueId,
}};
export default connect(mapStateToProps, { siteboardAction, setDeleteScheduleDialogueId })(DeleteScheduleDialogue);
